module.exports = __webpack_public_path__ + "assets/img/3.7cf53da3.png";